import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import EChallanRegNo from "../e-challan-reg-no";
import { Helmet } from "react-helmet-async";

const EChallanHeroBannerV2 = ({
    heroBannerData,
    regNumberList = []
}) => {

    const {
        title = "",
        description = [],
        inputChallanData = {},
        desktopBackgroundImage = {}
    } = heroBannerData || {};

    const {url = "", alternativeText = ""} = desktopBackgroundImage || {};

    return (
        <div
            styleName={"styles.heroContainer"}
            style={{
                background: `linear-gradient(0deg, rgba(0, 0, 0, 0.70) 0%, rgba(0, 0, 0, 0.70) 100%), url(${url}) lightgray 50% / cover no-repeat`
            }}
        >
            <span role="img" aria-label={alternativeText} />
            <Helmet>
                <link
                    rel="preload"
                    href={url}
                    as={"image"}
                    type="image/webp"
                    fetchpriority="high"
                />
            </Helmet>

            <div styleName={"styles.contentWrapper"}>
                <div styleName={"styles.content"}>
                    <h1>{title}</h1>
                    <div styleName={"styles.contentList"}>
                        {
                            description.map((item, index) => (
                                <div key={`point_${index}`} styleName={"styles.listItem"}>
                                    <span styleName={"styles.bulletPoint"}>•</span>
                                    <p>{item.text ? item.text : item?.title}</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <div styleName={"styles.formWrapper"}>
                    <div styleName={"styles.formContainer"}>
                        <EChallanRegNo isChallanRevamp challanCountData={inputChallanData} regNumberList={regNumberList} />
                    </div>
                </div>
            </div>
        </div>
    );
};

EChallanHeroBannerV2.propTypes = {
    heading: PropTypes.string,
    heroBannerData: PropTypes.object,
    regNumberList: PropTypes.array,
    isState: PropTypes.bool
};

export default EChallanHeroBannerV2;
